import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { CheckBox, StatusWarning } from '_components';
import styles from './Common.module.css';


class AlTemplateAquaRow extends React.Component {

    render() {
        return (
            <div className={styles.row}>
                <CheckBox
                    size='extra-small'
                    className={styles.checkbox}
                    checked={this.props.activity.selected}
                    title={this.props.desc}
                    label={this.props.desc}
                    onClick={() => this.props.toggleItem({ entity: 'MLTMPAQUATICS', entityKeyColumn: 'XLTMPAQNO', entityKeyValue: this.props.activity.XLTMPAQNO })}
                />
                { !this.props.activity.valid &&
                    <span className={styles.warning}>
                        <StatusWarning size='extra-small' title='Not Reimbursable based on Payer/Contract' />
                    </span>
                }
            </div>
        );
    }

}

function mapDispatchToProps(dispatch) {
    return {
        toggleItem: bindActionCreators(noteActions.alTemplateToggleItem, dispatch)
    };
}

function mapStateToProps(state, ownprops) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let activity = state.entities.notes.MLTMPAQUATICS[ownprops.id];
    let aqname = activity.XLTMPAQAQNO ? state.entities.masterData.MLMASTERAQUATICS[activity.XLTMPAQAQNO].AQNAME + ' - ' : '';
    let act = activity.XLTMPAQACTIVITY ? activity.XLTMPAQACTIVITY + ' - ' : '';
    let setsReps = activity.XLTMPAQSETSREPS ? activity.XLTMPAQSETSREPS + ' - ' : '';
    let desc = aqname + act + setsReps;
    desc = desc.endsWith(' - ') ? desc.slice(0, -3) : desc;

    return {
        noteId: noteId,
        activity: activity,
        desc: desc
    };
}

const connectedAlTemplateAquaRow = connect(mapStateToProps, mapDispatchToProps)(AlTemplateAquaRow);
export { connectedAlTemplateAquaRow as AlTemplateAquaRow };

